import { AppEntitySchema, entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const StationId = entityId('station')

export type StationIdType = typeof StationId.Type

export const StationSchema = AppEntitySchema.extend({
  id: StationId.schema,
  ownerId: z.string(),
  name: z.string().nullish(),
  specialization: z.string().nullish(),
  phone: z.string().nullish(),
  fax: z.string().nullish(),
  email: z.string().nullish(),
  comment: z.string().nullish(),
})
export const StationRefSchema = z.object({
  id: StationId.ref,
})

export const RecipeContactPointStationRefSchema = StationRefSchema.extend({
  recipeContactPoint: z.boolean().default(false),
})

export type StationRef = z.infer<typeof StationRefSchema>

export type RecipeContactPointStationRef = z.infer<typeof RecipeContactPointStationRefSchema>

export type Station = z.infer<typeof StationSchema>

export function isStation(val: unknown): val is Station {
  return (
    typeof val === 'object' &&
    val !== null &&
    'id' in val &&
    'name' in val &&
    typeof val.id === 'string' &&
    StationId.is(val.id)
  )
}
